import { styled } from '@mui/material/styles';
import { shouldForwardProp } from '../helpers/utilityFunctions/utilityFunctions';

type IAlertCircleStyleProps = {
  fill: string;
  'data-testid'?: string;
};

const AlertCircle = styled('div', {
  shouldForwardProp: (prop) =>
    shouldForwardProp<IAlertCircleStyleProps>(['fill'], prop),
})<IAlertCircleStyleProps>(({ fill }) => ({
  //border: "1px solid black",
  display: 'flex',
  width: '20px',
  height: '20px',
  backgroundColor: fill,
  borderRadius: '50%',
  margin: 'auto',
}));

export default AlertCircle;
